(function () {
  'use strict';
  var targets = {
    'personalisation': ['.io-personalisation-card-test', '.personalise_checkbox'],
    'unique-3d': ['.io-promoted-premade-3d', '.unique3dpm_checkbox', '.unique3d_checkbox'],
    'aged': ['[data-tone-cards-experiment]', '[data-pdp-aged-tone-proxy]', '.option_colour_tone'],
    'pop-art': ['.pop_art_text_checkbox'],
    '3d-colour': ['.option_3d_colour'],
    'artist-border': ['.artist_name_checkbox']
  };
  var requestId = 0;
  function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

  function findOption(root, option) {
    var selectors = targets[option] || [];
    for (var i = 0; i < selectors.length; i += 1) {
      var candidates = root.querySelectorAll(selectors[i]);
      for (var j = 0; j < candidates.length; j += 1) {
        var candidate = candidates[j];
        // Accordion contents are hidden until opened; unavailable options are
        // different and must not become a destination (e.g. duplicate 3D).
        if (!candidate.closest('.hide-oos-disable, [hidden]')) return candidate;
      }
    }
    return null;
  }

  async function scrollToExampleOption(option) {
    if (!targets[option]) return;
    var id = ++requestId;
    var deadline = Date.now() + 1500;
    var root, target;
    do {
      root = document.getElementById('infiniteoptions-container');
      target = root && findOption(root, option);
      if (target) break;
      await wait(50);
    } while (id === requestId && Date.now() < deadline);
    if (!target || id !== requestId) return;

    var panel = target.closest('[data-io-more-personalisation-panel], .io-more-personalisation-panel');
    if (panel && root.getAttribute('data-io-more-personalisation-expanded') !== 'true') {
      var control = root.querySelector('[data-io-more-personalisation-control]') ||
        root.querySelector('[data-io-more-personalisation-toggle] button');
      if (control) control.click();
    }

    // Older product layouts can also have a section accordion. Only open it
    // when the target is still hidden, so promoted cards stay independent.
    if (!target.getClientRects().length) {
      var section = option === 'personalisation' ? 'personalisation' : 'finish';
      var header = root.querySelector('h3[data-sm-section-title="' + section + '"][data-um-accordion-bound="1"]');
      if (header && header.getAttribute('aria-expanded') !== 'true') header.click();
    }
    if (typeof window.ioPingLayout === 'function') window.ioPingLayout();

    // Resolve again after layout settles: IO can replace a native option row
    // with its card while opening the accordion.
    await wait(180);
    if (id !== requestId) return;
    target = findOption(root, option);
    if (!target || !target.getClientRects().length) return;
    var card = target.closest('.io-promoted-premade-3d, .io-personalisation-card-test, .io-card, .sm__box-container') || target;
    card.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  document.addEventListener('click', function (event) {
    var badge = event.target.closest && event.target.closest('[data-pdp-example-option]');
    if (!badge) return;
    event.preventDefault();
    event.stopPropagation();
    scrollToExampleOption(badge.getAttribute('data-pdp-example-option'));
  }, true);
})();
